import { Link } from "react-router-dom";
const StatsCard = (props) => {
  return (
    <div className="bg-gray-800 text-white p-4 rounded-xl relative h-[120px] shadow-lg w-full min-w-[230px] max-w-[270px]">
      {props.icon}

      <div className="flex justify-between h-[80%] relative z-10 space-x-4 -mb-2">
        <div className="text-2xl font-bold">{props.details.number}</div>
        <div className="text-2xl font-bold">{props.details.name}</div>
      </div>
      <Link to={props.details.url}>
        <p className="text-sm text-center py-2 bg-black/20 text-white-900">
          View Details
        </p>
      </Link>
    </div>
  );
};

export default StatsCard;
